import { Fragment, useState } from "react";
import { Col, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import AddAddressDrawer from "../Drawers/AddAddress";
import DefaultPlaceholder from "../../../../../components/Placeholders/Default";
import AddressCard from "../../../../../components/Cards/AddressCard";
import ConfirmationModal from "../../../../../components/Modals/Confirmation";
import { del } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";

function AddressesTab({ isNew, customerData, localAddresses, onLocalAdd, onLocalEdit, onLocalDelete, onSaved }) {
  const { t } = useTranslation();
  const [addAddressOpen, setAddAddressOpen] = useState(false);
  const [editAddressData, setEditAddressData] = useState(null);
  const [addressToDelete, setAddressToDelete] = useState(null);

  const addresses = isNew ? localAddresses : (customerData?.addresses || []);

  const deleteAddress = async () => {
    if (isNew) {
      onLocalDelete?.(addressToDelete);
      setAddressToDelete(null);
      return;
    }
    const data = await del('/crm/customers/addresses/delete/' + addressToDelete);
    if (data.success) {
      toast.success(data.message || t('address.deleteAddress'));
      onSaved();
    } else {
      toast.error(data.message || t('common.somethingWentWrong'));
    }
    setAddressToDelete(null);
  }

  const handleLocalSave = (data) => {
    if (data._tempId && editAddressData?._tempId) {
      onLocalEdit?.(data._tempId, data);
    } else {
      onLocalAdd?.(data);
    }
  };

  return(
    <Fragment>
      <Row className="g-3">
        {addresses.length > 0 &&
          addresses.map((data, key) => (
            <Col md="6" key={isNew ? data._tempId : key}>
              <AddressCard
                data={data}
                onEditClick={() => {
                  setEditAddressData(data);
                  setAddAddressOpen(true);
                }}
                onDeleteClick={() => setAddressToDelete(isNew ? data._tempId : data.id)}
              />
            </Col>
          ))
        }
        <Col md="6">
          <DefaultPlaceholder
            onClick={() => {
              setEditAddressData(null);
              setAddAddressOpen(true);
            }}
          >
            + {t('common.address')}
          </DefaultPlaceholder>
        </Col>
      </Row>

      <AddAddressDrawer
        isOpen={addAddressOpen}
        toggle={() => setAddAddressOpen(!addAddressOpen)}
        isNew={isNew}
        customerData={customerData}
        editData={editAddressData}
        onSaved={onSaved}
        onLocalSave={handleLocalSave}
      />

      <ConfirmationModal
        isOpen={!!addressToDelete}
        toggle={() => setAddressToDelete(null)}
        title={t('address.deleteAddress')}
        message={t('address.deleteAddressConfirm')}
        onConfirm={deleteAddress}
      />
    </Fragment>
  );
}

export default AddressesTab;
